import { CustomerV2 } from '../../../Customer/Model/CustomerModel';
import { Tenant } from '../../Model/FarmModel';

export const areTenantsEqual = (tenant1: Tenant, tenant2: Tenant): boolean => {
  return JSON.stringify(tenant1) === JSON.stringify(tenant2);
};

export const getTenantSubDomain = (
  customers: CustomerV2[] | undefined,
  tenantId: string,
): string | undefined => {
  return customers?.find(
    (customer) =>
      customer.Id?.toLocaleLowerCase() === tenantId.toLocaleLowerCase(),
  )?.Subdomain;
};
